import LinkButton from 'assets/components/button/LinkButton';
import ThemeButtonLink from 'assets/components/button/themes/Theme.Button.Link';
import FormatValue from 'assets/components/formatValue/FormatValue';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import Sidebar from 'assets/templates/sidebar/Sidebar';
import { defaultDateTimeFormat, localizeDate } from 'assets/utils/data/Date';
import PaymentType from 'models/enums/PaymentType';
import { useClaimJobPaymentItemProvider } from '../Finance.ClaimJobPaymentItem.Hooks';
import ClaimJobPaymentItemInfoContractDetails from './other/Finance.ClaimJobPaymentItem.Info.ContractDetails';
import ClaimJobPaymentItemInfoJobDetails from './other/Finance.ClaimJobPaymentItem.Info.JobDetails';
export default function ClaimJobPaymentItemInfo() {
  const { lang, translate } = getLocales();
  const { selected, pageRouter, permissions } = useClaimJobPaymentItemProvider();

  return !selected ? null : (
    <Sidebar
      onClose={() => pageRouter.updateParams({})}
      icon={<Icon class="if-database" />}
      title={`${selected.claimJob.claim?.number}-J${selected.claimJob.jobNumber}`}
      content={
        <>
          <h3>{lang.info}</h3>
          <div>
            {lang.paymentMethod}:{' '}
            <b>{translate(Object.values(PaymentType).find((it) => it === selected.paymentMethodCode))}</b>
          </div>
          <div>
            {lang.payeeName}: <b>{selected.claimJobItemPayee?.displayInfo?.title}</b>
          </div>
          <div>
            {lang.payeeType}: <b>{selected.claimJobItemPayee?.payeeType?.name}</b>
          </div>
          <div>
            {lang.payeeEmail}:{' '}
            <b>
              {selected.claimJobItemPayee?.getEmailForPayment({
                clientOverrideEmail: selected.claimJob?.claim?.contactEmail,
              }) ?? 'N/A'}
            </b>
          </div>
          <div>
            {lang.payeeAddress}: <b>{selected.claimJobItemPayee?.fullAddress ?? 'N/A'}</b>
          </div>
          <div>
            {lang.createdBy}: <b>{selected.createdBy?.fullName ?? 'N/A'}</b>
          </div>
          <div>
            {lang.createdAt}:{' '}
            <b>{selected.createdAtLocal ? localizeDate(selected?.createdAtLocal, defaultDateTimeFormat) : 'N/A'}</b>
          </div>

          {selected.claimJob && <ClaimJobPaymentItemInfoJobDetails claimJob={selected.claimJob} />}

          {selected.claimJob.claim?.contract && (
            <ClaimJobPaymentItemInfoContractDetails contract={selected.claimJob.claim.contract} />
          )}

          <h3>{lang.invoices}</h3>
          {selected.claimJob.claim?.claimInvoices?.map((it) => (
            <div key={'invoice_' + it.id}>
              {it.name}{' '}
              <LinkButton
                class={ThemeButtonLink}
                url={it.mediaFile?.url}
                target="_blank"
                disabled={!it.mediaFile?.id || !it.mediaFile?.url || !permissions?.DOWNLOAD_CLAIMINVOICE}
              >
                {lang.download}
              </LinkButton>
            </div>
          ))}

          <h3>{lang.prices}</h3>
          <div>
            {lang.ttl}:{' '}
            <b>
              <FormatValue value={`${(selected.totalAmountBeforeTax || 0).toFixed(2)}$`} />
            </b>
          </div>
          <div>
            {lang.deductible}:{' '}
            <b>
              <FormatValue value={`${(selected.totalDeductibleAmount || 0).toFixed(2)}$`} />
            </b>
          </div>
          <div>
            {selected.currency === 'CAD' ? lang.gstHst : lang.tax}:{' '}
            <b>
              <FormatValue value={`${(selected.gstHstAmount || 0).toFixed(2)}$`} />
            </b>
          </div>
          {selected.currency === 'CAD' && (
            <div>
              {lang.pst}:{' '}
              <b>
                <FormatValue value={`${(selected.provincialSalesTaxAmount || 0).toFixed(2)}$`} />
              </b>
            </div>
          )}
          <hr />
          <div>
            {lang.total}:{' '}
            <b>
              <FormatValue value={`${(selected.total || 0).toFixed(2)}$`} />
            </b>
          </div>
        </>
      }
    />
  );
}
